import React, { useEffect, useState } from "react";
import "./index.scss";
import CustomModal from "../../core/modal";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import SiTable from "../../core/table";
import { getHeaderConfig } from "./config";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { useNavigate } from "react-router-dom";
import { getOfflineData } from "../../utils/offline-services";
import { toast } from "react-toastify";
import { Add, ArrowForward } from "@mui/icons-material";
import CustomButtonComponent from "../../core/custom-button";
import CustomTable from "../../core/custom-table";
import ComplaintFilters from "./complaint-filters";
import { PAGE_LIMIT } from "../../utils";
const Complaint = () => {
  const [complaint, setComplaint] = useState({
    results: [],
  });
  const [addComplaint, setAddComplaint] = useState(false);
  const [mainFilters, setMainFilters] = useState({});
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    type: "complaint",
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });
  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else {
      loadData(filters);
    }
  }, []);
  const addComplaintFormHandler = () => {
    setAddComplaint(true);
  };
  const addCodeHandler = (event) => {
    setCode(event.target.value);
  };
  const addDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };
  const payload = {
    type: "complaint",
    code: code,
    description: description,
  };
  //Show All Complaints
  const loadData = (filters) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.List_CODES}`,
      null,
      filters
    )
      .then((response) => {
        if (response) {
          setComplaint(response);
        }
      })
      .catch((err) => console.error(err));
  };
  //Add New Complaint
  const formSubmitHandler = () => {
    if (payload.code !== "" && payload.description !== "") {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.CODES}complaint`,
        payload,
        { active: true }
      )
        .then((response) => {
          if (response.message) {
            toast.error(response.message);
          } else {
            loadData(filters);
            setCode("");
            setDescription("");
            setAddComplaint(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  useEffect(() => {
    if (
      complaint?.totalPages !== 0 &&
      complaint?.totalPages < complaint?.page
    ) {
      setFilters({ ...filters, page: 1 });
      loadData({
        ...filters,
        ...mainFilters,
        page: 1,
      });
    }
  }, [complaint]);
  return (
    <>
      <div className="page-body">
        <div className="create-con">
          <div>
            <p className="tab-name">Setup</p>
            <p className="section-name">Complaint Codes</p>
          </div>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            onClick={addComplaintFormHandler}
          >
            Add Complaint Code
          </CustomButtonComponent>
        </div>

        <div className="si-hide-mobile">
          <CustomTable
            header={getHeaderConfig(loadData, filters)}
            data={complaint.results || []}
            pageCount={complaint.totalPages}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                ...mainFilters,
                page,
              });
            }}
            filterCom={
              <ComplaintFilters
                loadData={loadData}
                setMainFilters={setMainFilters}
                filter={filters}
              />
            }
          />
        </div>
        {addComplaint && (
          <CustomModal
            title="New Complaint Code"
            onClose={() => setAddComplaint(false)}
          >
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                fullWidth
                id="code"
                label="Code"
                sx={{ m: 1 }}
                onChange={addCodeHandler}
                value={code}
                size="small"
              />
              <TextField
                fullWidth
                id="description"
                label="Description"
                multiline
                sx={{ m: 1 }}
                rows={4}
                onChange={addDescriptionHandler}
                value={description}
                size="small"
              />
              <Stack
                direction="row"
                spacing={2}
                sx={{ m: 1, justifyContent: "flex-end" }}
              >
                <Button
                  variant="outlined"
                  color="error"
                  fullWidth
                  onClick={() => {
                    setAddComplaint(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={formSubmitHandler}
                >
                  Save
                </Button>
              </Stack>
            </Box>
          </CustomModal>
        )}
      </div>
    </>
  );
};

export default Complaint;
